import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["variant"];

var _templateObject;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { TOAST_VARIANTS, TOAST_VARIANT_ICONS } from "../constants";
import { ToastIcon } from "../elements";
import { getRem } from "./../../core";
import { jsx as _jsx } from "react/jsx-runtime";
var StyledToastIconContainer = styled.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['variant'].includes(prop);
  }
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  align-items: flex-start;\n  background-color: ", ";\n  border-bottom-left-radius: ", ";\n  border: 1px solid ", ";\n  border-top-left-radius: ", ";\n  box-sizing: border-box;\n  display: flex;\n  flex-shrink: 0;\n  justify-content: center;\n  padding: ", ";\n  width: ", ";\n"])), function (_ref) {
  var theme = _ref.theme,
      variant = _ref.variant;
  return theme.color.system[variant][500].value;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.size.borderRadius.large.value;
}, function (_ref3) {
  var theme = _ref3.theme,
      variant = _ref3.variant;
  return theme.color.system[variant][500].value;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.size.borderRadius.large.value;
}, function (_ref5) {
  var theme = _ref5.theme;
  return "".concat(getRem('14px'), " ").concat(theme.size.spacing.small.value);
}, getRem('32px'));

var ToastIconContainer = function ToastIconContainer(_ref6) {
  var variant = _ref6.variant,
      other = _objectWithoutProperties(_ref6, _excluded);

  var Icon = TOAST_VARIANT_ICONS[variant];
  return /*#__PURE__*/_jsx(StyledToastIconContainer, _objectSpread(_objectSpread({
    variant: variant
  }, other), {}, {
    children: /*#__PURE__*/_jsx(ToastIcon, {
      children: /*#__PURE__*/_jsx(Icon, {})
    })
  }));
};

ToastIconContainer.displayName = "ToastIconContainer";
ToastIconContainer.propTypes = {
  /** Changes style depending on variant. Default 'Neutral' */
  variant: PropTypes.oneOf(Object.values(TOAST_VARIANTS))
};
ToastIconContainer.defaultProps = {
  variant: TOAST_VARIANTS.NEUTRAL
};
export { ToastIconContainer };